export default __webpack_public_path__ + "static/media/entrepriseRetexLogo.5b95c1f4.webp";